import classNames from "classnames";
import { useNavigationToggle } from "../../../../contexts/NavigationContext";
import Icon from "../../../atoms/Icon";
import styles from "./styles.scss";

const NaviMenuSPToggleButton = () => {
  const { isNavigationOpen, toggleNavigation } = useNavigationToggle();

  return (
    <button
      className={classNames(styles.root, { [styles.opened]: isNavigationOpen })}
      onClick={toggleNavigation}
    >
      <div>
        <Icon name="icon-close-x" className={styles.iconClose} />
      </div>
    </button>
  );
};

export default NaviMenuSPToggleButton;
